import styled from 'styled-components';
import { BodyText } from '../../../ui-toolkit';

export const DangerText = styled(BodyText)`
  color: ${(props) => props.theme.colors.errorText};
`;
